import { Component, OnInit, ViewChild } from '@angular/core';
import { CatalogoService } from '../../../services/tools/catalogos.service';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { ProductosService } from '../../../services/productos.service';
import { ModalSeleccionProductosComponent } from './modal-seleccion-productos/modal-seleccion-productos.component';
import { ModalConfirmarServicioComponent } from './modal-confirmar-servicio/modal-confirmar-servicio.component';
import { VentasService } from '../../../services/ventas.service';
import {Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-formulario-servicio-general',
  templateUrl: './formulario-servicio-general.component.html',
  styleUrls: ['./formulario-servicio-general.component.scss']
})
export class FormularioServicioGeneralComponent implements OnInit {
    @ViewChild(ModalSeleccionProductosComponent) modalSeleccionProductos: ModalSeleccionProductosComponent;
    @ViewChild(ModalConfirmarServicioComponent) modalConfirmarServicio: ModalConfirmarServicioComponent;

    //Modelos
    public producto: any = { activo: true };
    public proveedor_buscado: boolean = false;
    public productos: any[] = [];
    public periodos: any[] = [];
    public obras_emisoras: any = {};
    public tiposServicios: any[] = [];
    public venta: any = { 
      cliente: {}, 
      venta_productos: [] 
    };
    public bcliente: any = [];

    //UI
    public errors: any = {}; 

    //helpers
    public tipoSeleccionado: any = { valor: '' }; 
    public periodicidadSeleccionada: any = {};
    public permitirEditar: boolean = true;
    public obraEmisora: any = {};
    public totales: any = { cantidad: 0, importeTotal: 0 };
    public loadingTiposProductos: boolean = false;
    public buscandoCliente: any = false;
    public loading: any = false;
    public proveedor_busqueda_mensaje: string = null;
    public mensaje1='Aplicar Retencion';
    public mensaje2='Eliminar Retencion';
    //Subscriptions
    private sub: any;

    constructor(private catalogoService: CatalogoService,
      private cuentasPorCobrarService: CuentasPorCobrarService,
      private productosService: ProductosService,
      private ventasService: VentasService,
      private activeRoute: ActivatedRoute) {
      }
      
    ngOnInit() {
      this.cargarCatalogos();
      this.sub = this.activeRoute.params.subscribe(params => {
        if(params['id_venta']){
          //Edit mode
          let id_venta = params['id_venta'] ? +params['id_venta'] : 0; // (+) converts string 'id' to a number
          this.cargarVenta(id_venta);              
        } 
      });
    }
    
    private cargarClientes(){
      //define la carga de clientes 
       this.cuentasPorCobrarService.getProveedores2()
         .subscribe((response)=>{
           let content = response.json().content;  
        
           this.bcliente =content;

         });   
     }
    private cargarCatalogos(){
      this.cargarClientes();
      this.cargarPeriodos();
      this.cargarTipoServicios();
      this.cargarObrasEmisoras();
    }

    private cargarPeriodos(){
      let periodos = this.catalogoService.getCatalogoPeriodos()

      //Selecciona el periodo default: Menual
      periodos.forEach(periodo => {
        if(periodo.default === true){
          this.changePeriodicidad(periodo);
        }
      });
      
      this.periodos = periodos;
    }

    private cargarTipoServicios(){
      this.loadingTiposProductos = true;
      this.productosService.listarTiposServicios()
      .subscribe(
          (response)=> {
              this.loadingTiposProductos = false;
              let content = response.json().content;
              this.tiposServicios = content;
          
          },
          (error) => {
          this.loadingTiposProductos = false;
          }
      );
    }

    public changePeriodicidad(event){
      this.periodicidadSeleccionada = event;
      this.venta.periodicidad = event.descripcion;
    }

    private cargarObrasEmisoras(){
      this.cuentasPorCobrarService.getObrasEmisoras()
        .subscribe((response) => {
          this.obras_emisoras = response.json().content;
        });
    }

    public mostrarModalSeleccionProductos(){
      this.modalSeleccionProductos.openModal(this.tipoSeleccionado.id_tipo_servicio);
    }

    public guardar(){

      let venta = this.venta;

      this.errors = this.ventasService.validar(venta, this.tipoSeleccionado.descripcion);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      this.modalConfirmarServicio.openModal(venta);
    }   
    public aplicarRetencion(producto){
      let index = 0;
      let salirDelCiclo = false;
      let productos = this.venta.venta_productos;
      while(index < productos.length && !salirDelCiclo){
        if(producto.id_producto === productos[index].id_producto){
        
          productos[index].retencion=true;
          
          salirDelCiclo = true;
         
        }
        index++;
      }
      this.actualizarTotales();

    }
    public eliminarRetencion(producto){
   
      let index = 0;
      let salirDelCiclo = false;
      let productos = this.venta.venta_productos;
      while(index < productos.length && !salirDelCiclo){
        if(producto.id_producto === productos[index].id_producto){
          productos[index].retencion=false;
          
          salirDelCiclo = true;
        }
        index++;
      }
      this.actualizarTotales();

    }

    public productosSeleccionados(producto){
      let productoVenta = { 
        cantidad : 1, producto, 
        importe_bruto: producto.importe_bruto,
        id_producto: producto.id_producto ,
        concepto_facturar: producto.nombre,
        retencion:false      //retencion por defecto en falso 
      };
      
      this.venta.venta_productos.push(productoVenta);
      this.actualizarTotales()
    }

    private actualizarTotales(){
      let cantidadTotal = 0;
      let importeTotal = 0;
      this.venta.venta_productos.forEach(function(producto) {
        //console.log(producto.retencion);
        let importe_bruto = Number(producto.importe_bruto);
        let cantidad = Number(producto.cantidad);
        producto.importe_neto = (importe_bruto * 0.16).toFixed(2);
        if(producto.retencion==true){
          producto.importe_total = (importe_bruto * cantidad * 1.10).toFixed(2);
        }else{
          producto.importe_total = (importe_bruto * cantidad * 1.16).toFixed(2);
        }
        
        cantidadTotal += cantidad;
        importeTotal += Number(producto.importe_total);
      });

      this.totales.cantidad = cantidadTotal;
      this.totales.importeTotal = importeTotal;
      
    }


    public eliminarProducto(producto){
     
      let index = 0;
      let salirDelCiclo = false;
      let productos = this.venta.venta_productos;
      while(index < productos.length && !salirDelCiclo){
        if(producto.id_producto === productos[index].id_producto){
          //Elimino el item del arreglo
          productos.splice(index, 1);
          salirDelCiclo = true;
        }
        index++;
      }
      this.actualizarTotales();
    }

    public buscarCliente(rfc2){
      this.proveedor_busqueda_mensaje = null;
      
      //Si no se ha ingresado un RFC, limpiamos el formulario del cliente
//      if(!this.venta.cliente.rfc || this.venta.cliente.rfc.length == 0){  
//        this.limpiarFormularioCliente();
//        return;
//      }
      
      this.buscandoCliente = true;
      this.cuentasPorCobrarService.buscarProveedorPorRFC(rfc2)
      .subscribe(response => {
          let content = response.json().content;
          this.venta.cliente = content;
          this.venta.email_facturacion = content.email;
          this.venta.id_cliente = content.idProveedores;

          this.proveedor_buscado = true;
          this.buscandoCliente = false;
      },
      error => {
        this.buscandoCliente = false;
        if(error.status==404){
          this.proveedor_busqueda_mensaje = "Puedes dar de alta al cliente a continuación";
          this.proveedor_buscado = true;
          this.venta.id_cliente = null;
          //this.limpiarFormularioCliente(this.venta.cliente.rfc);
        }
      });
    }

    public buscarClientePorId(id){
      console.log(id);
      this.proveedor_busqueda_mensaje = null;
      
      //Si no se ha ingresado un RFC, limpiamos el formulario del cliente
//      if(!this.venta.cliente.rfc || this.venta.cliente.rfc.length == 0){  
//        this.limpiarFormularioCliente();
//        return;
//      }
      
      this.buscandoCliente = true;
      this.cuentasPorCobrarService.buscarProveedorPorId(id)
      .subscribe(response => {
          let content = response.json().content;
          this.venta.cliente = content;
          this.venta.email_facturacion = content.email;
          this.venta.id_cliente = content.idProveedores;

          this.proveedor_buscado = true;
          this.buscandoCliente = false;
      },
      error => {
        this.buscandoCliente = false;
        if(error.status==404){
          this.proveedor_busqueda_mensaje = "Puedes dar de alta al cliente a continuación";
          this.proveedor_buscado = true;
          this.venta.id_cliente = null;
          //this.limpiarFormularioCliente(this.venta.cliente.rfc);
        }
      });
    }


    public nuevaBusqueda(){
      this.proveedor_buscado = false;
      this.venta.cliente ={}
    }

    private limpiarFormularioCliente(rfc: string = null){
      this.venta.cliente = { rfc };
      this.proveedor_buscado = true;
      this.venta.id_cliente = null;
    }

    private cargarVenta(id_venta){
      this.loading = true;
      this.ventasService.obtenerVenta(id_venta)
      .subscribe(
          (response)=> {
              this.loading = false;
              let venta = response.json().content;
              venta.email_facturacion = venta.cliente.email;
              let component = this;
              
              //Seleccionar tipo de servicio
              this.tiposServicios.some(tipo => {
                if(tipo.id_tipo_servicio === venta.id_tipo_servicio){
                  component.tipoSeleccionado = tipo;
                  return true;
                }
                return false;
              })

              //Seleccionar emisor
              this.obras_emisoras.some(obra => {
                if(obra.idObras === venta.id_emisor){
                  component.obraEmisora = obra;
                  return true;
                }
                return false;
              })

              //Si la venta no tiene una periodicidad definida seleccionamos la default
              venta.periodicidad = this.periodicidadSeleccionada.descripcion;
              
              //Mostrar el formulario del cliente
              this.proveedor_buscado = true;
              this.venta = venta;         

              //La lista  de productos viene en la propiedad venta_productos
              this.actualizarTotales();

          },
          (error) => {
          this.loading = false;
          }
      );
    }

    public changeObraEmisorFilter($event){
      this.obraEmisora = $event;
      this.venta.id_emisor = this.obraEmisora.idObras;
    }

    public seleccionaTipoServicio($event){
      this.tipoSeleccionado = $event;
      this.venta.id_tipo_servicio = this.tipoSeleccionado.id_tipo_servicio;
      //Reiniciamos la lista de productos ya que por ahora no se deben mezclar
      this.venta.venta_productos = [];
    }

    public actualizarEmail(event){
      this.venta.email_facturacion = this.venta.cliente.email;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modulo-servicios/formulario-servicio-general/formulario-servicio-general.component.ts